<template>
  <div id="schools-homepage">
    <!-- if no school is selected -->
    <transition name="fade">
      <template v-if="!school && !notFoundSchool">
        <SchoolSearchBar
          :schoolKeyword="schoolKeyword"
          :selectedSchool="selectedSchool"
          :customOption="'Cant find the right school?'"
          :hideAddNewSchoolOption="true"
          v-on="{
            onSchoolSelected: handleSchoolSelected,
            onCustomOptionSelect: handleCustomOptionSelected,
            input: handleUpdateSchoolKeyword,
            
          }"
        />
        <!-- todo add custom action in last row -->
      </template>

      <template v-else-if="!confirmedPersonalizations && hasDecorationsConfigurator">
        <Personalizations
          @updatePersonalization="handleConfirmPersonalizations"
          @updatePersonalizationsTab="handleUpdatePersonalizationsTab"
        />
      </template>

      <template v-else-if="confirmedPersonalizations">
        <ProductsSelection
          @updatePersonalizationsTab="handleUpdatePersonalizationsTab"
        />
      </template>
    </transition>
  </div>
</template>

<script>
import CONSTANTS from "@/constants.js";

import SchoolSearchBar from "@/components/Dashboard/CreateNewProject/SchoolSearchBar";
import Personalizations from "@/components/Projects/Showrooms/Homepage/Personalizations";
import ProductsSelection from "@/components/Projects/Showrooms/Homepage/ProductsSelection";
import { mapActions } from "vuex";

export default {
  name: "SchoolsPath",

  computed: {},

  methods: {
    ...mapActions("showroom", ["updateShowroomColor", "selectSchool"]),

    hasDecorationsConfigurator() {
      return window.decorationsConfigurator != null
    },

    getColorIdByColorName(color) {
      return CONSTANTS.COLORS.find((c) => c.name === color)?.id;
    },

    handleSchoolSelected(payload) {
      this.schoolKeyword = payload.name;
      this.mascot = payload.mascot;
      this.school = payload;

      //Converting color name to id color
      this.school.color_1 = this.getColorIdByColorName(this.school.color_1);
      this.school.color_2 = this.getColorIdByColorName(this.school.color_2);
      this.school.color_3 = this.getColorIdByColorName(this.school.color_3);
      this.selectSchool({
        school: this.school,
        mascot: this.mascot,
      });

      //reste next step
      this.confirmedPersonalizations = false;
    },

    handleCustomOptionSelected() {
      this.notFoundSchool = true;
      this.confirmedPersonalizations = false;
    },

    handleUpdateSchoolKeyword(payload) {
      this.schoolKeyword = payload;
    },

    handleConfirmPersonalizations(bool) {
      this.confirmedPersonalizations = bool;
    },

    //let the parent comp know we are now customizing colors, used for home title
    handleUpdatePersonalizationsTab(tab) {
      this.$emit("personalizationsTabActive", tab);
    },

    handleResetSchool() {
      this.selectSchool(null);
    }
  },

  mounted() {
    this.handleUpdatePersonalizationsTab(false);
    this.handleResetSchool();
  },

  data() {
    return {
      schoolKeyword: "",
      school: null,
      mascot: "",
      selectedSchool: "",
      notFoundSchool: false,
      confirmedPersonalizations: false,
    };
  },

  components: {
    SchoolSearchBar,
    Personalizations,
    ProductsSelection,
  },
};
</script>